export type ValueTFn<T = any> = T extends (...args: unknown[]) => unknown ? never : T | (() => T);

export namespace ValueTFn {
  export function valueOf<T = any>(valueOrFn: ValueTFn<T>): T {
    return typeof valueOrFn === 'function' ? (valueOrFn as () => T)() : (valueOrFn as T);
  }
}

export interface AstralOption<TValue = any> {
  name: string;
  value: TValue | null;
  readonly disabled?: boolean | null;
  setDisabled?(value: ValueTFn<boolean | null>): void;
  filterData?: { [key: string]: TValue };
  icon?: string;
}

export class SelectionItemImpl<TValue = any> implements AstralOption<TValue> {
  constructor(
    public readonly name: string = 'ALL_TEXT',
    public readonly value: TValue | null = null,
    disabled?: ValueTFn<boolean | null>,
    public readonly filterData?: { [key: string]: TValue },
    public readonly icon?: string
  ) {
    this._disabled = disabled;
  }

  private _disabled?: ValueTFn<boolean | null>;

  public get disabled(): boolean | null {
    return ValueTFn.valueOf(this._disabled) || null;
  }

  public set disabled(value: ValueTFn<boolean | null>) {
    this._disabled = value;
  }

  public setDisabled(value: ValueTFn<boolean | null>): void {
    this._disabled = value;
  }
}

interface AstralOptionConstructor {
  new <TValue = any>(): AstralOption<TValue>;
  new <TValue = any>(
    name: string,
    value: TValue,
    disabled?: ValueTFn<boolean>,
    filterData?: { [key: string]: TValue },
    icon?: string
  ): AstralOption<TValue>;
  prototype: SelectionItemImpl<any>;
}

export type SelectionItem<TValue = any> = AstralOption<TValue>;
export const SelectionItem: AstralOptionConstructor = SelectionItemImpl;
export type ISelectionItem<TValue = any> = AstralOption<TValue>;
export { SelectionItemImpl as AstralOptionImpl };
